import React, { Component } from 'react';
import "./Resume.css";
import LeftHeader from "./LeftHeader";
import CenterHeader from "./CenterHeader";
import RightHeader from "./RightHeader";
import Skills from "./Skills";
import GoodSonApps from "./GoodSonApps";
import Linq3 from "./Linq3";
import EchoStar from "./EchoStar";
import Motorola from "./Motorola";
import Bootcamp from "./Bootcamp";
import Clemson from "./Clemson";
import BeeGaTech from "./BeeGaTech";

class Resume extends Component {
   render() {
      return (
         <div className="container page resume">

            <div className="row">
               <LeftHeader/>
               <CenterHeader/>
               <RightHeader/>
            </div>{/* End of  <div className="row"> */}

            <div className="row">
               <div className="col-md-12">
                  <Skills/>
                  <GoodSonApps></GoodSonApps>
                  <Linq3/>
                  <EchoStar/>
                  <Motorola/>
                  <Bootcamp/>
                  <Clemson/>
                  <BeeGaTech/>
               </div>{/* End of <div className="col-md-12> */}

            </div>{/* End of  <div className="row"> */}
         </div> // End of <div class="container page">
      ); // End of return ( ... )
   } // End of render()
} // End of class Resume

export default Resume;



// WEBPACK FOOTER //
// ./src/components/Resume/Resume.js